import React, { memo } from 'react';

/**
 * 우주 배경 애니메이션 컴포넌트
 * React.memo로 메모이제이션하여 불필요한 리렌더링 방지
 * GPU 가속 최적화 적용
 */
export const CosmicBackground: React.FC = memo(() => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* 그라디언트 구체 */}
      <div className="cosmic-sphere absolute w-96 h-96 -top-20 -right-20 bg-gradient-to-br from-indigo-500/30 to-purple-600/30"></div>
      <div className="cosmic-sphere absolute w-72 h-72 -bottom-10 -left-10 bg-gradient-to-br from-pink-500/20 to-purple-500/20"></div>
      
      {/* 별들 */}
      <div className="cosmic-star" style={{ top: '10%', left: '20%', animationDelay: '0s' }}></div>
      <div className="cosmic-star" style={{ top: '20%', left: '80%', animationDelay: '0.3s' }}></div>
      <div className="cosmic-star" style={{ top: '40%', left: '10%', animationDelay: '0.6s' }}></div>
      <div className="cosmic-star" style={{ top: '60%', left: '90%', animationDelay: '0.9s' }}></div>
      <div className="cosmic-star" style={{ top: '80%', left: '30%', animationDelay: '1.2s' }}></div>
      <div className="cosmic-star" style={{ top: '15%', left: '50%', animationDelay: '1.5s' }}></div>
      <div className="cosmic-star" style={{ top: '70%', left: '70%', animationDelay: '0.2s' }}></div>
      <div className="cosmic-star" style={{ top: '35%', left: '40%', animationDelay: '0.8s' }}></div>
      <div className="cosmic-star" style={{ top: '55%', left: '15%', animationDelay: '1.1s' }}></div>
      <div className="cosmic-star" style={{ top: '25%', left: '65%', animationDelay: '0.5s' }}></div>
      
      {/* 유성 (별똥별) */}
      <div className="shooting-star" style={{ top: '10%', left: '70%' }}></div>
      <div className="shooting-star" style={{ top: '25%', left: '45%', animationDelay: '3s' }}></div>
      <div className="shooting-star" style={{ top: '8%', left: '85%', animationDelay: '6s' }}></div>
    </div>
  );
});

CosmicBackground.displayName = 'CosmicBackground';

